import { Routes, Route, Navigate } from 'react-router-dom';
import { SingleCard } from './layouts';
import { ResetPasswordForm } from './components';
import AuthCallback from './AuthCallback';

export default function UnauthenticatedContent() {
    return (
        <Routes>
            <Route path="/auth-callback" element={<AuthCallback />} />
            <Route path='*' element={<Navigate to='/home' />} />
        </Routes>
    );
}